<form [formGroup]="_formGroup" class="w-100 border-t pt-3">
  <div class="mb-5">
    <span class="h4">Countdowns</span>
  </div>

  <div class="flex flex-col gap-5 w-full">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Start Type</mat-label>
      <mat-select
        placeholder="Start"
        [formControl]="startType"
        [value]="startType.value"
        (selectionChange)="onStartTypeChange()"
      >
        <mat-option [value]="EExerciseStartType.FULL_COUNTDOWN"
          >Full Countdown</mat-option
        >
        <mat-option [value]="EExerciseStartType.RANDOM">Random</mat-option>
      </mat-select>
      <mat-error *ngIf="ValidationHelperService.isInvalid(startType)">
        {{ ValidationHelperService.getErrorMessage(startType) }}
      </mat-error>
    </mat-form-field>

    <mat-form-field
      class="w-full"
      appearance="outline"
      *ngIf="startType.value === EExerciseStartType.FULL_COUNTDOWN"
    >
      <mat-label>After how many seconds</mat-label>
      <input
        type="number"
        step="1"
        min="1"
        max="999"
        [formControl]="startValue"
        matInput
        [value]="startValue.value"
      />
      <mat-error *ngIf="ValidationHelperService.isInvalid(startValue)">
        {{ ValidationHelperService.getErrorMessage(startValue) }}
      </mat-error>
      <mat-error *ngIf="_formGroup.touched && _formGroup.errors?.['startValueRequired']">
        Select a countdown start value greater than zero.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="w-full" appearance="outline">
      <mat-label>End Type</mat-label>
      <mat-select
        placeholder="End"
        [formControl]="endType"
        [value]="endType.value"
      >
        <mat-option [value]="ECountdownEndType.TOUCHES">
          {{ usesArrowCountdown ? "Arrows" : "Touches" }}
        </mat-option>
        <mat-option [value]="ECountdownEndType.TIME">Seconds</mat-option>
      </mat-select>
      <mat-error *ngIf="ValidationHelperService.isInvalid(endType)">
        {{ ValidationHelperService.getErrorMessage(endType) }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>
        After how many
        {{ endType.value | endType: _exerciseType.value: _companionMode?.value }}
      </mat-label>
      <input
        matInput
        type="number"
        step="1"
        min="1"
        max="999"
        [formControl]="endValue"
        [value]="endValue.value"
      />
      <mat-error *ngIf="ValidationHelperService.isInvalid(endValue)">
        {{ ValidationHelperService.getErrorMessage(endValue) }}
      </mat-error>
    </mat-form-field>
  </div>
</form>
